import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core";
import * as i18n from "../common/i18n";
import MaterialTable from 'material-table'
import { reactLocalStorage } from 'reactjs-localstorage';
import LinearProgress from '@material-ui/core/LinearProgress';
import gql from 'graphql-tag';
import Message from "./Message";
import * as graphql from '../common/graphql';
import * as helper from "../common/helper";
import moment from "moment";
import ReloadIcon from '@material-ui/icons/Replay';
import QueuePlayNextIcon from '@material-ui/icons/QueuePlayNext';
import { CsvBuilder } from 'filefy';
import Chip from '@material-ui/core/Chip';
import * as validator from "validator";
import TapWizard from "./TapWizard";
import { withIAM, isInRoles, ROLE_ADMIN, ROLE_READER, ROLE_OWNER, ROLE_ASSISTANT, ROLE_EDITOR } from "../common/iam";

const styles = theme => ({
});


const defaults = {
    id: true,
    name: false,
    valve: false,
    faucet: false,
    parcel: false,
    tenant: false,
    pageSize: 20,
};


const defaultsPropertyName = 'p71.taps.defaults';

class Taps extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            wizard: false,
            message: null,
            details: null,
            hideAfter: 3000,
            variant: "info",
            building: null,
            userSettings: reactLocalStorage.getObject(defaultsPropertyName, defaults),
        };

        this.tableRef = React.createRef();
    }

    default(id) {
        return this.state.userSettings[id] !== undefined ? this.state.userSettings[id] : defaults[id];
    }

    setDefault(id, value) {

        const newUserSettings = { ...this.state.userSettings };
        newUserSettings[id] = value;

        this.setState({ userSettings: newUserSettings }, () => {
            reactLocalStorage.setObject(defaultsPropertyName, newUserSettings);
        });
    }

    getInput = (data) => {
        try {
            if (
                validator.isEmpty(`${data.parcel}`)
            ) {
                throw new Error(i18n.get("parcels.error.validation"));
            }

            const input = {}

            helper.set(input, data, "name");
            helper.set(input, data, "parcel");
            helper.set(input, data, "faucet");
            helper.set(input, data, "valve");
            helper.set(input, data, "building");
            helper.set(input, data, "tenant");

            return input;

        } catch (error) {
            throw new Error(i18n.get("parcels.error.validation"))
        }
    }

    getUpdatedInput = (data) => {
        try {
            if (
                validator.isEmpty(`${data.parcel}`)
            ) {
                throw new Error(i18n.get("parcels.error.validation"));
            }

            const input = {}

            helper.set(input, data, "id");
            helper.set(input, data, "name");
            helper.set(input, data, "faucet");
            helper.set(input, data, "valve");

            if (!input["name"]) input["name"] = null
            if (!input["faucet"]) input["faucet"] = null
            if (!input["valve"]) input["valve"] = null

            return input;

        } catch (error) {
            throw new Error(i18n.get("parcels.error.validation"))
        }
    }
    mapField(column) {
        return column;
    }

    getParcelSuggestions = async (value) => {
        try {
            const where = `[{column: "name", comparator: LIKE, string: "${value}"}]`;

            const result = await graphql.clientWithToken(this.props.accessToken).query({
                query: gql`
                query {
                    parcels(first: 5, offset: 0, where:${where} orderBy: [{column: "id", direction: ASC}]) {
                        totalCount
                        elements {
                            ... on Parcel {
                                name
                                id
                           }
                        }
                    }
                }
            `,
                fetchPolicy: 'no-cache',
            });

            return result.data.parcels.elements.map((element) => {
                return {
                    name: helper.parcelChipOf(element.name, element.id),
                    value: element.id,
                };
            });
        } catch (error) {
            console.log(error.message);
            return [];
        }
    };

    getBuildingSuggestions = async (value) => {
        try {
            const where = `[{column: "street", comparator: LIKE, string: "${value}"}]`;

            const result = await graphql.clientWithToken(this.props.accessToken).query({
                query: gql`
                query {
                    buildings(first: 5, offset: 0, where:${where} orderBy: [{column: "id", direction: ASC}]) {
                        totalCount
                        elements {
                            ... on Building {
                                street
                                id
                           }
                        }
                    }
                }
            `,
                fetchPolicy: 'no-cache',
            });

            return result.data.buildings.elements.map((element) => {
                return {
                    name: helper.buildingChipOf(element.street, element.id),
                    value: element.id,
                };
            });
        } catch (error) {
            console.log(error.message);
            return [];
        }
    };

    getTenantSuggestions = async (value) => {
        try {
            const where = `[{column: "company", comparator: LIKE, string: "${value}"}]`;

            const result = await graphql.clientWithToken(this.props.accessToken).query({
                query: gql`
                query {
                    tenants(first: 5, offset: 0, where:${where} orderBy: [{column: "id", direction: ASC}]) {
                        totalCount
                        elements {
                            ... on Tenant {
                                id
                                company

                           }
                        }
                    }
                }
            `,
                fetchPolicy: 'no-cache',
            });

            return result.data.tenants.elements.map((element) => {
                return {
                    name: helper.tenantChipOf(element.company, element.id),
                    value: element.id,
                };
            });
        } catch (error) {
            console.log(error.message);
            return [];
        }
    };

    getDefaultSuggestions = () => {
        return [];
    };

    hasChildren = async (id) => {
        try {

            const result = await graphql.clientWithToken(this.props.accessToken).query({
                variables: {
                    "id": id,
                },
                query: gql`
                query leases($id: String!) { 
                    leases (where: [{column: "tap" comparator: IS string: $id}]) {
                        elements {
                        ... on Lease {
                            id
                        }
                    }
                }
            }
            `,
                fetchPolicy: "no-cache"
            });

            return result.data.leases.elements.length > 0

        } catch (error) {
            console.log(error.message);
            return false
        }
    }

    handleWizardCancel = () => {
        this.setState({ wizard: false, working: false })
    }

    handleWizardSave = (newData) => {
        this.setState({ wizard: false, working: false });
        new Promise(async (resolve, reject) => {
            try {

                const input = this.getInput(newData)
                const result = await graphql.clientWithToken(this.props.accessToken).mutate({
                    variables: {
                        "input": input,
                    },
                    mutation: gql`
                    mutation addTap($input: TapInput!) {
                        addTap(input: $input) {
                            id
                        }
                    }
                `,
                });

                this.showMessage(i18n.get("taps.message.onAdd.success"), "success")
                this.tableRef.current.onQueryChange();
                resolve();
            } catch (error) {
                this.showMessage(i18n.get("taps.message.onAdd.error"), "error", error.message);
                reject(error);
            }
        })
    }

    exportCsv = async (columns, data) => {

        try {

            this.setState({
                exporting: true,
                progressValue: 0
            });

            const allTaps = [];
            let totalCount = 0;
            const first = 100;
            let offset = 0

            this.showMessage("Export wird angestoßen. Bitte verlassen Sie die Seite nicht, solange der Exportvorgang läuft.", "info");

            do {

                const filters = []
                for (const column of columns) {
                    if (column.tableData.filterValue !== undefined && column.tableData.filterValue !== null) {
                        filters.push({
                            column: column,
                            field: column.field,
                            type: column.type,
                            comparator: column.comparator,
                            value: column.tableData.filterValue
                        })
                    }
                }

                const find = helper.whereString(filters, this.mapField, ["id"]);

                const result = await graphql.clientWithToken(this.props.accessToken).query({
                    query: gql`
                    query {
                        taps(first: 100, offset: ${offset}, where: ${find}, orderBy: [{column: "id" direction: ASC}]) {
                            totalCount
                            elements {
                            ... on Tap {
                                id
                                name
                                valve
                                faucet
                                parcel {
                                    name
                                }
                                building {
                                    street
                                }
                                tenant {
                                    company
                                }
                            }
                        }
                        }
                    }
                `,
                    fetchPolicy: "no-cache"
                });

                totalCount = result.data.taps.totalCount;
                offset = offset + first;
                for (const tap of result.data.taps.elements) {
                    allTaps.push(
                        {
                            name: tap.name,
                            valve: tap.valve,
                            faucet: tap.faucet,
                            street: tap.building ? tap.building.street : '-',
                            parcelName: tap.parcel ? tap.parcel.name : '-',
                            tenant: tap.tenant ? tap.tenant.company : '-',
                            id: tap.id,
                        }
                    )
                }

                if (totalCount !== 0) {
                    this.setState({
                        exporting: true,
                        progressValue: (allTaps.length / totalCount) * 100
                    });
                }
            } while (allTaps.length < totalCount);

            const builder = new CsvBuilder('Anschlüsse.csv')
                .setDelimeter(";")
                .setColumns(columns.map(columnDef => columnDef.title))
                .addRows(allTaps.map(tap => { return [tap.name, tap.valve, tap.faucet, tap.street, tap.parcelName, tap.tenant, tap.id] }))
                .exportFile();

            this.setState({
                exporting: false,
                progressValue: 0
            });
        } catch (error) {
            this.setState({
                exporting: false,
                progressValue: 0
            });
            this.showMessage(error.message, "error");
        }

    }

    showMessage = (message, variant, details, hideAfter) => {
        this.setState({
            message: message,
            variant: variant ? variant : "info",
            hideAfter: hideAfter ? hideAfter : 3000,
            details: details ? details : null,
        })
    }

    closeMessage = () => {
        this.setState({
            message: null,
            details: null,
            hideAfter: 3000,
            variant: "info",
        })
    }

    render() {

        return (
            <div style={{ maxWidth: '100%' }}>

                {this.state.exporting && <div style={{ width: "100%" }}><LinearProgress value={this.state.progressValue} variant={"determinate"} /></div>}

                <MaterialTable
                    components={{
                        Cell: helper.defaultCell,
                        FilterRow: helper.defaultFilter
                    }}
                    icons={helper.tableIcons}
                    onChangeRowsPerPage={pageSize => { this.setDefault("pageSize", pageSize) }}
                    onChangeColumnHidden={data => { this.setDefault(data["field"], data["hidden"]) }}
                    tableRef={this.tableRef}
                    localization={i18n.getLocalization()}
                    columns={[
                        {
                            title: i18n.get("taps.name"),
                            field: 'name',
                            hidden: this.default("name"),
                            cellStyle: {
                                minWidth: '400px',
                                maxWidth: '400px',
                            },
                            headerStyle: {
                                minWidth: '400px',
                                maxWidth: '400px',
                            },
                            sorting: true,
                            filtering: true
                        },
                        {
                            title: i18n.get("taps.valve"),
                            field: 'valve',
                            hidden: this.default("valve"),
                            cellStyle: {
                                minWidth: '400px',
                                maxWidth: '400px',
                            },
                            headerStyle: {
                                minWidth: '400px',
                                maxWidth: '400px',
                            },
                            sorting: true,
                            filtering: true
                        },
                        {
                            title: i18n.get("taps.faucet"),
                            field: 'faucet',
                            hidden: this.default("faucet"),
                            cellStyle: {
                                minWidth: '400px',
                                maxWidth: '400px',
                            },
                            headerStyle: {
                                minWidth: '400px',
                                maxWidth: '400px',
                            },
                            sorting: true,
                            filtering: true
                        },
                        {
                            title: i18n.get("taps.building"),
                            field: 'building',
                            hidden: this.default("building"),
                            cellStyle: {
                                minWidth: '500px',
                                maxWidth: '500px',
                            },
                            headerStyle: {
                                minWidth: '500px',
                                maxWidth: '500px',
                            },
                            sorting: true,
                            filtering: true,
                            editable: 'onAdd',
                            comparator: 'IS',
                            filterComponent: helper.chipsFilter(
                                (items, props) =>
                                    props.onFilterChanged(
                                        props.columnDef.tableData.id,
                                        items.map((item) => `${item.value}`)
                                    ),
                                (value) =>
                                    value.map((v) => {
                                        return {
                                            name: `${v.label}`,
                                            value: v.id,
                                        };
                                    }),
                                this.getBuildingSuggestions,
                                this.getDefaultSuggestions
                            ),
                            render: (rowData) => {
                                if (rowData) {
                                    return rowData.building && rowData.building.street ? <Chip label={rowData.building.street} /> : 'n/a';
                                }
                            },
                        },
                        {
                            title: i18n.get("taps.parcel"),
                            field: 'parcel',
                            hidden: this.default("parcel"),
                            cellStyle: {
                                minWidth: '400px',
                                maxWidth: '400px',
                            },
                            headerStyle: {
                                minWidth: '400px',
                                maxWidth: '400px',
                            },
                            sorting: true,
                            filtering: true,
                            editable: 'onAdd',
                            comparator: 'IS',
                            filterComponent: helper.chipsFilter(
                                (items, props) =>
                                    props.onFilterChanged(
                                        props.columnDef.tableData.id,
                                        items.map((item) => `${item.value}`)
                                    ),
                                (value) =>
                                    value.map((v) => {
                                        return {
                                            name: `${v.label} (${v.id})`,
                                            value: v.id,
                                        };
                                    }),
                                this.getParcelSuggestions,
                                this.getDefaultSuggestions
                            ),
                            render: rowData => { return rowData && rowData.parcel ? <Chip label={rowData.parcel.name ? `${rowData.parcel.name} (${rowData.parcel.id})` : `${rowData.parcel.id}`} /> : null },
                        },
                        {
                            title: i18n.get("taps.tenant"),
                            field: 'tenant',
                            hidden: this.default("tenant"),
                            cellStyle: {
                                minWidth: '600px',
                                maxWidth: '600px',
                            },
                            headerStyle: {
                                minWidth: '600px',
                                maxWidth: '600px',
                            },
                            editable: 'never',
                            comparator: 'IS',
                            filterComponent: helper.chipsFilter(
                                (items, props) =>
                                    props.onFilterChanged(
                                        props.columnDef.tableData.id,
                                        items.map((item) => `${item.value}`)
                                    ),
                                (value) =>
                                    value.map((v) => {
                                        return {
                                            name: `${v.company}`,
                                            value: v.id,
                                        };
                                    }),
                                this.getTenantSuggestions,
                                this.getDefaultSuggestions
                            ),
                            sorting: true,
                            filtering: true,
                            render: (rowData) => {
                                if (rowData) {
                                    return rowData && rowData.tenant ? <Chip label={rowData.tenant.company} /> : 'n/a';
                                }
                            },
                        },
                        {
                            title: i18n.get("taps.id"),
                            field: 'id',
                            hidden: this.default("id"),
                            cellStyle: {
                                minWidth: '200px',
                                maxWidth: '200px',
                            },
                            headerStyle: {
                                minWidth: '200px',
                                maxWidth: '200px',
                            },
                            defaultFilter: (this.props.pageData && this.props.pageData.id) || null,
                            sorting: true,
                            filtering: true,
                            editable: 'never',
                        },
                    ]}
                    data={query =>
                        new Promise(async (resolve, reject) => {

                            try {

                                const where = helper.whereString(query['filters'], this.mapField, ["id"]);
                                let orderBy = helper.orderByString(query, this.mapField, 'id', true);
                                if (where === "[]") {
                                    orderBy = helper.orderByString(query, this.mapField, "id")
                                }

                                const result = await graphql.clientWithToken(this.props.accessToken).query({
                                    query: gql`
                                    query {
                                        taps (first: ${query.pageSize}, offset: ${query.pageSize * query.page}, orderBy:${orderBy}, where:${where}) {
                                            totalCount
                                            elements {
                                            ... on Tap {
                                                id
                                                name
                                                valve
                                                faucet
                                                parcel {
                                                    id
                                                    name
                                                }
                                                building {
                                                        id
                                                        street
                                                }
                                                tenant {
                                                    company
                                                }
                                            }
                                        }
                                    }
                                }
                                `,
                                    fetchPolicy: "no-cache"
                                });

                                const searchResult = {
                                    page: query.page,
                                    data: result.data.taps.elements.map(
                                        (element) => {
                                            return {
                                                id: element.id,
                                                name: element.name,
                                                valve: element.valve,
                                                faucet: element.faucet,
                                                building: element.building,
                                                parcel: element.parcel,
                                                tenant: element.tenant,
                                            };
                                        }),
                                    totalCount: result.data.taps.totalCount
                                }
                                resolve(searchResult);
                            } catch (error) {
                                this.showMessage(error.message, "error");
                                reject(error);
                            }
                        })
                    }
                    actions={[
                        {
                            isFreeAction: true,
                            icon: QueuePlayNextIcon,
                            tooltip: i18n.get("taps.addTap.tooltip"),
                            onClick: async (event, rowData) => {

                                this.setState({
                                    wizard: true,
                                })
                            }
                        },
                        {
                            isFreeAction: true,
                            icon: () => { return <ReloadIcon /> },
                            tooltip: i18n.get("general.reload"),
                            onClick: async (event, rowData) => {
                                this.tableRef.current.onQueryChange();
                            }
                        }]}
                    title={i18n.get("taps.title")}
                    options={{
                        addRowPosition: "first",
                        exportButton: !this.state.exporting,
                        filtering: true,
                        showTitle: false,
                        debounceInterval: 500,
                        search: false,
                        columnsButton: true,
                        exportCsv: this.exportCsv,
                        pageSize: this.default("pageSize"),
                        pageSizeOptions: [5, 20, 50]
                    }}

                    editable={{
                        isEditable: rowData => isInRoles(this.props.roles, [ROLE_ADMIN, ROLE_OWNER, ROLE_EDITOR]),
                        isDeletable: rowData => isInRoles(this.props.roles, [ROLE_ADMIN, ROLE_OWNER, ROLE_EDITOR]),
                        onRowUpdate: (newData, oldData) =>
                            new Promise(async (resolve, reject) => {

                                try {

                                    const input = this.getUpdatedInput(newData);

                                    const result = await graphql.clientWithToken(this.props.accessToken).mutate({
                                        variables: {
                                            "id": newData.id,
                                            "input": input,
                                        },
                                        mutation: gql`
                                        mutation updateTap($id: ID!, $input: TapInput!) {
                                            updateTap(id: $id, input: $input) {
                                                id
                                            }
                                        }
                                    `,
                                    });

                                    this.showMessage(i18n.get("taps.message.onRowUpdate.success"), "success")

                                    resolve(result);

                                } catch (error) {

                                    this.showMessage(i18n.get("taps.message.onRowUpdate.error"), "error", error.message)
                                    reject(error);
                                }
                            }),
                        onRowDelete: oldData =>
                            new Promise(async (resolve, reject) => {

                                try {
                                    const hasChildren = await this.hasChildren(oldData.id)

                                    if (!hasChildren) {
                                        const result = await graphql.clientWithToken(this.props.accessToken).mutate({
                                            variables: {
                                                "id": oldData.id,
                                            },
                                            mutation: gql`
                                            mutation deleteTap($id: ID!) {
                                                deleteTap(id: $id)
                                            }
                                        `,
                                        });

                                        this.showMessage(i18n.get("taps.message.onRowDelete.success"), "success")

                                        resolve(result);

                                    } else {
                                        this.showMessage(i18n.get("taps.message.onRowDelete.notEmpty"), "error")
                                        reject();
                                    }

                                } catch (error) {
                                    this.showMessage(i18n.get("taps.message.onRowDelete.error"), "error", error.message)
                                    reject(error);
                                }
                            }),
                    }}

                />

                <Message
                    hideAfter={this.state.hideAfter}
                    onClose={this.closeMessage}
                    variant={this.state.variant}
                    message={this.state.message}
                    details={this.state.details}
                    open={this.state.message !== null}
                />

                <TapWizard
                    open={this.state.wizard}
                    working={this.state.working}
                    onCancel={this.handleWizardCancel}
                    accessToken={this.props.accessToken}
                    onSave={this.handleWizardSave} />

            </div>
        )
    }
}

Taps.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withIAM(withStyles(styles, { withTheme: true })(Taps))